<template>
    <UserWrapper>
        <h2 class="rg-title">個別連絡一覧</h2>
            <div class="contact-detail">
                <div class="desktop-view">
                    <Loader v-if="loading" />
                    <table>
                        <thead>
                            <tr>
                                <th style="width: 25%">会社名</th>
                                <th style="width: 15%;">差出人</th>
                                <th style="width: 30%">件名</th>
                                <th style="width: 10%">受信日</th>
                                <th style="width: 10%">回答内容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="msg in contacts" :key="msg._id" :class="checkUnread(msg)" @click="openContactPage(msg._id)">
                                <td class="d-none d-sm-table-cell">{{ msg.company.name }}</td>
                                <td class="d-none d-sm-table-cell">{{ msg.sender }}</td>
                                <td class="d-none d-sm-table-cell">{{ msg.subject }}</td>
                                <td class="d-none d-sm-table-cell text-center">{{ formatDate(msg.sent_date) }}</td>
                                <td class="d-none d-sm-table-cell text-center">{{ msg.user_response }}</td>

                                <td class="d-flex d-sm-none flex-row justify-content-between pb-0">
                                    <div class="w-65">{{ msg.company.name }}</div>
                                    <div>{{ formatDate(msg.sent_date) }}</div>
                                </td>
                                <td class="d-flex d-sm-none flex-row justify-content-between">
                                    <div class="w-65">{{ msg.sender }}</div>
                                    <div>{{ msg.user_response }}</div>
                                </td>
                                <td class="d-flex d-sm-none flex-row justify-content-between">
                                    <div class="w-65">{{ msg.subject }}</div>
                                </td>
                            </tr>
                            <tr v-if="showEmptyMessage" style="border-bottom: none !important;">
                                <td colspan="100%" class="text-center" style="border-bottom: none !important;">連絡先が見つかりません</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="pagination-area" v-if="totalPages > 1">
                        <Pagination :total-page="totalPages" :callback="changePage" />
                    </div>
                </div>
            </div>
        <template v-slot:footer>
            <Footer/>
        </template>
    </UserWrapper>
</template>

<script>
import Api from '@/config/api';
import moment from 'moment';
// import ProfileHeader from "@/components/header.vue";
import UserWrapper from '../UserWrapper.vue';
import Pagination from '../Pagination.vue';
import Loader from '../Loader.vue';
import Footer from '../Footer.vue';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
export default {
    name: 'TopContacts',
    components: { UserWrapper, Pagination, Loader, Footer },
    data(){
        return {
            loading: false,
            // contacts: [],
        }
    },
    computed: {
        ...mapGetters({ contacts:'getContacts', totalContacts: 'getTotalContacts' }),
        ...mapState({
            page: ({ contact }) => contact.currentPage,
        }),
        allContactsCount() {
            return this.contacts.length;
        },
        totalPages(){
            return this.totalContacts ? Math.ceil(this.totalContacts/20) : 0;
        },
        showEmptyMessage() {
            return this.contacts.length === 0;
        }
    },
    methods: {
        ...mapActions(['loadContacts']),
        ...mapMutations(['setPage']),
        formatDate(date){
            return moment(date).format("YYYY[年]MM[月]DD[日]");
        },
        changePage(page){
            this.setPage(page);
        },
        checkUnread(msg){
            if(msg.is_read) {
                return 'read'
            } else {
                return 'unread'
            }
        },
        openContactPage(id){
            // console.log(id);
            this.$router.push({
                name: 'contactDetails',
                params: { id },
            })
        },
        async loadTopContacts(){
            try {
                const token = await this.$auth.getToken();
                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                // console.log(Api.endpoints);
                const contacts = await this.axios({
                    method: 'get',
                    url: Api.url(`${Api.endpoints.allMessages}?page=${page}`),
                    headers: headers,
                });
                // console.log(contacts);
                this.contacts = contacts.data.data;
            } catch (err) {
                console.log(err);
            }
        }
    },
    async created(){
        this.loading = true;
        this.setPage(1);
        await this.loadContacts(1);
        this.loading = false;
    },
    watch: {
        page: function(currentPage) {
            this.loadContacts(currentPage);
        }
    }
}
</script>

<style scoped>

.profile-detail-block table thead th {
    background: none !important;
}
.contact-detail {
    padding: 10px;
}
.text-center {
    text-align: center;
}
.w-65 {
    width: 65%;
}
.unread {
    cursor: pointer;
    font-weight: bold !important;
}

.read {
    cursor: pointer;
    background-color: #E6E6E6;
}
.contact-button-container {
    padding: 20px 0 40px 0;
}

.contact-btn {
    float: right;
    padding: 0;
    border: 1px solid #006c6b;
    color: #006c6b;
    background: #ffffff;
    width: 250px;
    height: 50px;
    text-align: center;
    font-size: 16px;
    font-size: 17px;
    border-radius: 4px;
    font-weight: 500;
}
>>>.profile-detail-block {
    padding: 25px 10px;
    background-color: #fff !important;
}
h2 {
    font-size: 24px;
}

table{
    width: 100%;
    text-align: center;
    border-collapse: collapse;
}
th {
    padding: 15px;
    font-size: 20px;
}
td {
    border-bottom: 1px solid #c4c4c4;
    padding: 8px;
    text-align: center;
    color: #2F2E41;
    font-size: 18px;
}

tr {
    text-align: center;
    border-bottom: 1px solid #c4c4c4;
}

.mobile-view {
    display: none;
}


@media(max-width: 550px) {

    >>>.profile-detail-block table td {
        padding-left: 8px !important;
        min-height: 0px;
    }

    .desktop-view{
        padding: 0px !important;
    }

    table thead {
        display: none !important;
    }

    table td, table th {
        font-size: 12px !important;
    }

    table td {
        padding: 5px 8px 0px 8px;
        border: 0px;
        text-align: left;
    }
    .rg-title {
        font-size: 16px !important;
        padding-top: 10px;
        padding-left: 5px
    }
    .mobile-view {
        display: block !important;
        padding: 10px;
    }

    .contact-button-container {
        padding: 10px;
        display: flex;
        justify-content: center;
    }
    .contact-btn {
        width: 90%;
        height: 40px;
        text-align: center;
    }
    >>>.profile-detail-block {
        padding: 10px !important
    }
    .contact-detail {
        padding: 0px !important;
        border: 1px solid rgba(1, 58, 61, 0.1);
        /* box-shadow: 0px 0px 20px -2px rgba(1, 58, 61, 0.1); */
    }
    /* .desktop-view {
        display: none !important;
    } */
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* CSS rules for iPads in portrait mode */

  >>>.profile-detail-block {
    padding: 20px;
  }
  .contact-detail {
    padding: 0px ;
 }
 table th{
    font-size:16px;
 }
  .button-wrapper span {
    flex-basis: 100%;
  }
  .delete-button {
    margin-left: 0px !important;
    margin-top: 5px;
  }
}

</style>